import { ChartTimeRange } from 'models/chart'

const chartHelper = {
  getSampleSpanByTimeRange: (timeRange: ChartTimeRange): string => {
    const sampleSpanMap = {
      '1-day': '15m',
      '5-days': '1h',
      '7-days': '1h',
      '1-month': '4h',
      '3-months': '1d',
      '6-months': '1d',
      '1-year': '1d',
      '2-years': '1d',
    }
    return sampleSpanMap[timeRange]
  },
  timeTooltipFormats: {
    '1-day': '%H:%M',
    '5-days': '%d.%m, %H:%M',
    '7-days': '%d.%m, %H:%M',
    '1-month': '%d.%m, %H:%M',
    '3-months': '%d-%m-%Y',
    '6-months': '%d-%m-%Y',
    '1-year': '%d-%m-%Y',
    '2-years': '%d-%m-%Y',
  },
  timeFlotFormats: {
    '1-day': '%H:%M',
    '5-days': '%d %b',
    '7-days': '%d %b',
    '1-month': '%d %b',
    '3-months': '%d %b',
    '6-months': '%d %b',
    '1-year': '%d %b',
    '2-years': '%d %b',
  },
}

export default chartHelper
